import {
  FIELD_TYPES,
  type DocType,
  type DocTypeSource,
  type FieldType,
  type UesFieldDef,
} from "../../domain/entities/doc-type";
import type { DocTypeModel, UESFieldDefModel } from "../models/doc-type-model";

const toFieldType = (v: unknown): FieldType =>
  FIELD_TYPES.includes(v as FieldType) ? (v as FieldType) : "string";

const toSource = (v: unknown): DocTypeSource =>
  v === "custom" ? "custom" : "system_seeded";

const toUesFieldDef = (m: UESFieldDefModel): UesFieldDef => ({
  name: m.name ?? "",
  label: m.label ?? "",
  description: m.description ?? "",
  required: m.required ?? false,
  type: toFieldType(m.type),
  isList: m.is_list ?? false,
  enumValues: m.enum_values ?? null,
  fields: m.fields ? m.fields.map(toUesFieldDef) : null,
});

export const toUesFieldDefModel = (e: UesFieldDef): UESFieldDefModel => ({
  name: e.name,
  label: e.label,
  description: e.description,
  required: e.required,
  type: e.type,
  is_list: e.isList,
  enum_values: e.type === "enum" ? (e.enumValues ?? []) : null,
  fields:
    e.type === "object" ? (e.fields ?? []).map(toUesFieldDefModel) : null,
});

export const toDocType = (m: DocTypeModel): DocType => ({
  id: m._id ?? "",
  key: m.key,
  displayName: m.display_name,
  description: m.description,
  uesFields: (m.ues_fields ?? []).map(toUesFieldDef),
  schemaVersion: m.schema_version,
  source: toSource(m.source),
  createdAt: m.created_at,
  updatedAt: m.updated_at,
});

export const toDocTypeList = (ms: DocTypeModel[]): DocType[] =>
  ms.map(toDocType);

export const toDocTypeCreateBody = (e: {
  key: string;
  displayName: string;
  description: string;
  uesFields: UesFieldDef[];
}) => ({
  key: e.key,
  display_name: e.displayName,
  description: e.description,
  ues_fields: e.uesFields.map(toUesFieldDefModel),
});

export const toDocTypeUpdateBody = (e: {
  displayName: string;
  description: string;
  uesFields: UesFieldDef[];
}) => ({
  display_name: e.displayName,
  description: e.description,
  ues_fields: e.uesFields.map(toUesFieldDefModel),
});
